const initialSlice = {
  data: null,
  error: null,
  loading: false,
};

const initialState = {
  summary: { ...initialSlice },
  slaAudit: { ...initialSlice },
  slaVeto: { ...initialSlice },
  expiring: { ...initialSlice },
  scheduleDelays: { ...initialSlice },
  orderTrend: { ...initialSlice },
  topCustomers: { ...initialSlice },
  topStandards: { ...initialSlice },
};

const SLICES = {
  DASHBOARD_V2_SUMMARY: "summary",
  DASHBOARD_V2_SLA_AUDIT: "slaAudit",
  DASHBOARD_V2_SLA_VETO: "slaVeto",
  DASHBOARD_V2_EXPIRING: "expiring",
  DASHBOARD_V2_SCHEDULE_DELAYS: "scheduleDelays",
  DASHBOARD_V2_ORDER_TREND: "orderTrend",
  DASHBOARD_V2_TOP_CUSTOMERS: "topCustomers",
  DASHBOARD_V2_TOP_STANDARDS: "topStandards",
};

export default (state = initialState, action) => {
  const match = /^(DASHBOARD_V2_.+)_(PENDING|FULFILLED|REJECTED)$/.exec(
    action.type
  );
  if (!match || !SLICES[match[1]]) {
    return state;
  }

  const slice = SLICES[match[1]];
  switch (match[2]) {
    case "PENDING":
      return {
        ...state,
        [slice]: { ...state[slice], loading: true, error: null },
      };
    case "FULFILLED":
      return {
        ...state,
        [slice]: { data: action.payload, error: null, loading: false },
      };
    case "REJECTED":
      return {
        ...state,
        [slice]: { ...state[slice], error: action.payload, loading: false },
      };
    default:
      return state;
  }
};
